import React, { useEffect, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import OtpInput from "react-otp-input";
import AuthHeader from "../../Auth/AuthHeader/AuthHeader";
import { translate } from 'react-i18next';
import "../../Auth/OTP/OTP.scss";
import headerLogo from "../../AsanLoginConfirmation/img/header-logo.svg";
import { request } from "../../../config";

const LoginWithMobileIndividualOtp = ({ t, updateAppState, }) => {
  const [OTPCode, setOTPCode] = useState();
  const [errMessage, setErrMessage] = useState();
  const [isVisible, setIsVisible] = useState(true);
  const [isAuthed, setIsAuthed] = useState(false);

  const initialMinute = 3,
    initialSeconds = 0,
    numInputs = 6;
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(initialSeconds);
  const [isDisabled, setIsDisabled] = useState(true);
  const case1 = "00:00";

  const resetTime = () => {
    setErrMessage("");
    setMinutes(initialMinute);
    setSeconds(initialSeconds);
    setIsDisabled(true);
    sendOtpCode();
  };

  const formatTime = (time) => {
    return time < 10 ? `0${time}` : time;
  };

  useEffect(() => {
    let timeInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(timeInterval);
          setIsDisabled(false);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);

    return () => {
      clearInterval(timeInterval);
    };
  });

  let history = useHistory();
  const { state } = useLocation();
  const location = useLocation();

  if (location.state === undefined) {
    // this.props.history.push('/login/juridical/asan/');
    window.location.href = '/login/individual/asan/';
    // console.log("error")
  }

  const handleOTP = (otp) => setOTPCode(otp);

  let { loginWithUsrAndPwdIndividualRequestBody, loginWithUsrAndPwdIndividualResponse } = location.state;
  const verifyToken = loginWithUsrAndPwdIndividualResponse.verifyToken
  const mobile = loginWithUsrAndPwdIndividualResponse.mobile
  // let { selectCustCompanyRequestBody, token, verifyToken } = location.state;
  const [verify, setIsVerify] = useState(verifyToken);

  useEffect(() => {
    setIsVerify(verifyToken);
  }, [verifyToken]);

  const sendOtpCode = (e) => {
    updateAppState("isLoadingTransparentBackground", true);
    fetch(request("register/getAuthInfoIndividualLogin", loginWithUsrAndPwdIndividualRequestBody))
      .then((res) => res.json())
      .then(
        (getAuthInfoIndividualLoginRequestResponse) => {
          if (getAuthInfoIndividualLoginRequestResponse.status.statusCode !== 1 && getAuthInfoIndividualLoginRequestResponse.status.statusCode !== 802 && getAuthInfoIndividualLoginRequestResponse.status.statusCode !== 803) {
            updateAppState("isLoadingTransparentBackground", false);
            setErrMessage(
              (getAuthInfoIndividualLoginRequestResponse.status.statusMessage)
            );
            setIsVisible(false)
          } else {
            setIsVerify(getAuthInfoIndividualLoginRequestResponse.verifyToken)
            // console.log("əlse")
            updateAppState("isLoadingTransparentBackground", false);
            // console.log(getAuthInfoIndividualLoginRequestResponse)
            // history.push("/sign-up/not-a-bank-customer/create-password", {
            //   custId: state.custId,
            // });
          }
        },
        (error) => {
          history.push("/technical-break");
        }
      );
  };

  const verifyOtpCode = (e) => {
    e.preventDefault();

    updateAppState("isLoadingTransparentBackground", true);
    setErrMessage("");

    fetch(request("register/loginWithUsrAndPwdIndividualV3", { ...loginWithUsrAndPwdIndividualRequestBody, otpCode: OTPCode, verifyToken: verify }))
      .then((res) => res.json())
      .then(
        (getAuthInfoIndividualLoginRequestResponse) => {
          if (getAuthInfoIndividualLoginRequestResponse.status.statusCode !== 1 && getAuthInfoIndividualLoginRequestResponse.status.statusCode !== 802 && getAuthInfoIndividualLoginRequestResponse.status.statusCode !== 803) {
            updateAppState("isLoadingTransparentBackground", false);
            setErrMessage(
              (getAuthInfoIndividualLoginRequestResponse.status.statusMessage)
            );
            // setIsVisible(false)
            // console.log('5 time')
          } 
          else {
            updateAppState("isLoadingTransparentBackground", false);
            let custId = "";
                    if (typeof (getAuthInfoIndividualLoginRequestResponse.custId) === "object" && getAuthInfoIndividualLoginRequestResponse.custId.hasOwnProperty('c')) {
                        getAuthInfoIndividualLoginRequestResponse.custId.c.forEach(part => {
                            custId += part;
                        });
                    }
                    else {
                        custId += getAuthInfoIndividualLoginRequestResponse.custId;
                    }
                    // =========FULLNAME=========
                    // let fullname = loginWithUsrAndPwdIndividualResponse.name[0].toUpperCase() + loginWithUsrAndPwdIndividualResponse.name.substring(1, loginWithUsrAndPwdIndividualResponse.name.length).toLowerCase() +
                    //     ' ' + loginWithUsrAndPwdIndividualResponse.surname[0].toUpperCase() + loginWithUsrAndPwdIndividualResponse.surname.substring(1, loginWithUsrAndPwdIndividualResponse.surname.length).toLowerCase() +
                    //     ' ' + loginWithUsrAndPwdIndividualResponse.patronymic[0].toUpperCase() + loginWithUsrAndPwdIndividualResponse.patronymic.substring(1, loginWithUsrAndPwdIndividualResponse.patronymic.length).toLowerCase();
                    let fullname = `${getAuthInfoIndividualLoginRequestResponse.surname} ${getAuthInfoIndividualLoginRequestResponse.name} ${getAuthInfoIndividualLoginRequestResponse.patronymic ? getAuthInfoIndividualLoginRequestResponse?.patronymic : ''}`
                    localStorage.setItem("custId", custId);
                    localStorage.setItem("token", getAuthInfoIndividualLoginRequestResponse.token);
                    localStorage.setItem("secretWord", loginWithUsrAndPwdIndividualResponse.secretWord);
                    localStorage.setItem("fullname", fullname);
                    localStorage.setItem("checkResident", JSON.stringify(getAuthInfoIndividualLoginRequestResponse.checkResident)); // TODO
                    localStorage.setItem("custObject", JSON.stringify(getAuthInfoIndividualLoginRequestResponse));
                    localStorage.setItem("bankCustomerType",getAuthInfoIndividualLoginRequestResponse.bankCustomerType);
                    localStorage.setItem("custTypeId", getAuthInfoIndividualLoginRequestResponse.custTypeId);
                    localStorage.setItem("custIdEncrypt", getAuthInfoIndividualLoginRequestResponse.custIdEncrypt);
                    updateAppState('isAuthed', true);
                    if (
                      getAuthInfoIndividualLoginRequestResponse.passwordChangeRequired === true ||
                      getAuthInfoIndividualLoginRequestResponse.status.statusCode === 802
                    ) {
                      const statusCode = getAuthInfoIndividualLoginRequestResponse.status.statusCode;
                      history.push(`/dashboard/settings/security/change-password?passwordChangeRequired=true&statusCode=${statusCode}`);
                    } else {
                        history.push('/dashboard/home');
                    }
            // history.push('/login/individual/asan/confirmation', { loginIndividualForAsanRequestBody });
          }
        },
        (error) => {
          history.push("/technical-break");
        }
      );
  };


  // useEffect(() => {
  //   if (location.state === undefined) {
  //     history.push("/sign-up/not-a-bank-customer")
  //   }
  //   else {
  //     updateAppState("isLoadingTransparentBackground", false)
  //   };
  // }, []);
  // console.log(initialMinute)
  // const { t } = translate();

  // useEffect(() => {
  //   if (isAuthed) {
  //     // Redirect to the desired page
  //     history.push('/dashboard/home');
  //     // window.location.href = '/dashboard/home';
  //   }
  // }, [isAuthed, history]);

  return (
    <div className="registration">
      <Link to="/">
        <img src={headerLogo} className="registration-logo" alt="headerLogo" />
      </Link>
      <div className="registration-container registration-container--top-border">
        <h2 className="registration-container-title registration-container-title--center">{t('otp code confirmation')}</h2>
      <p className="registration-container-title registration-container-title--center">{mobile}</p>

        {/* <p className="registration-container-description registration-container-description--center">please accept the request sent to your phone</p> */}
        <section className="ibank-otp header-sign-section">
          <div className="header-sign-section-container">
            <AuthHeader
              title={t("Enter the one-time code")}
              desc={[
                t("enter the 6-digit confirmation code sent to your phone"),
              ]}
            />
            <form onSubmit={verifyOtpCode}>
              <OtpInput
                className="ibank-otp__body"
                value={OTPCode}
                onChange={handleOTP}
                shouldAutoFocus={true}
                {...{ initialMinute, initialSeconds, numInputs }}
              />
              {isVisible &&
                (
                  <div className="ibank-otp__resend">
                    <button
                      disabled={isDisabled}
                      onClick={() => {
                        resetTime();
                      }}
                      type="button"
                    >
                      {t("resend the code")}
                    </button>
                    <p className="ibank-otp__resend__timer">
                      {minutes === 0 && seconds === 0
                        ? case1
                        : `${formatTime(minutes)} : ${formatTime(seconds)}`}
                    </p>
                  </div>
                )
                // <TimerCountdown
                //   resendTitle={t("resend the code")}
                //   {...{
                //     initialMinute,
                //     initialSeconds,
                //     sendOtpCode,
                //     setErrMessage,
                //   }}
                // />
              }

              <div className="registration-container-validation-feedback">
                {errMessage ? (
                  <p className="registration-container-validation-feedback-message">
                    {errMessage}
                  </p>
                ) : null}
              </div>
              <button
                className="header-sign-section-container-form-button"
                disabled={OTPCode?.length !== numInputs || (minutes === 0 && seconds === 0)}
              >
                {t("continue")}
              </button>
            </form>
          </div>
        </section>
        {/* <div className="registration-container-asan-confirmation">
        <span className="registration-container-asan-confirmation-code">{verificationCode}</span>
    </div> */}
        <div className="registration-container-validation-feedback"></div>
        <div className="registration-container-footer">
          {/* <button type="button" className="registration-container-footer-button registration-container-footer-button--left" onClick={this.prevPage}>{t('back')}</button> */}
          {/* <button type="button" className="registration-container-footer-button registration-container-footer-button--right" disabled={isDisabled}>{t('next')}</button> */}
        </div>
      </div>
    </div>
  );
};

export default translate("translation")(LoginWithMobileIndividualOtp);



